import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import * as ReactDOM from 'react-dom/client'
import { App } from './App'

library.add(fas, fab)

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
